var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.lock)?_c('router-view'):_c('div',{staticClass:"version-lock"},[_c('h4',[_vm._v("Ваша версия устарела")]),_vm._v(" "),_c('p',[_vm._v("У нас появились критические обновления, пожалуйста обновите приложение до последней версии")])]),_vm._v(" "),_c('div',{staticClass:"version"},[_vm._v(_vm._s(_vm.VERSION))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13baaff2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 